import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_cascader = _resolveComponent("a-cascader")!

  return (_openBlock(), _createBlock(_component_a_cascader, {
    class: "oio-select oio-cascader",
    value: _ctx.areaList,
    style: {"width":"100%"},
    multiple: "",
    "field-names": { label: 'name', value: 'code' },
    "max-tag-count": "responsive",
    options: _ctx.areaOptions,
    placeholder: "请选择地区",
    onChange: _ctx.onChange
  }, null, 8, ["value", "options", "onChange"]))
}